import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';

// alert
import alert from '@drivesally/sally-ui/lib/libs/alert';

// components

// error lib
import parseError from '@drivesally/sally-fw/lib/error/parseError';

// tesla api
import uploadEZPassTolls from '@drivesally/sally-fn/lib/toll/api/uploadEZPassTolls.api.toll';

// tesla components
import UploadEZPassTollsModal from '../../components/UploadEZPassTollsModal/UploadEZPassTollsModal';

class UploadEZPassTollsContainer extends Component {
  static defaultProps = {
    children: PropTypes.func,
  };

  state = {
    loading: false,
    visible: false,
  };

  show = () => this.setState({visible: true});

  hide = () => {
    if (this.state.loading) return;
    this.setState({visible: false});
  };

  upload = async ([file]) => {
    const {loading} = this.state;
    if (loading || !file) return;
    this.setState({loading: true});
    try {
      const fileName = 'ezpass_tolls.csv';
      const formMeta = new FormData();
      formMeta.append('csv_file', file, fileName);
      await uploadEZPassTolls(formMeta);
      alert.success('Tolls uploaded for processing.');
      this.setState({loading: false, visible: false});
    } catch (error) {
      const {message} = parseError(error);
      alert.error(message);
      this.setState({loading: false});
    }
  };

  render() {
    const {children} = this.props;
    const {loading, visible} = this.state;
    return (
      <Fragment>
        {children({showModal: this.show})}
        <UploadEZPassTollsModal
          loading={loading}
          visible={visible}
          onClose={this.hide}
          onUpload={this.upload}
        />
      </Fragment>
    );
  }
}

export default UploadEZPassTollsContainer;
